import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { generateRandomRoomId } from "../helper/common";
import { useSocketContext } from "../Context/socketContext";

const ROOM_ID = generateRandomRoomId();
const UNIQUE_ID = generateRandomRoomId();

const useBadlaOrder = ({ apiData }) => {
  const { socket } = useSocketContext();

  const indexingScriptRef = useRef({});
  const [instrumentData, setInstrumentData] = useState(apiData || []);

  // Build initial state + indexing map
  useEffect(() => {
    if (!apiData) return;

    const indexingMap = {};
    const initialData = apiData.map((script, rowIndex) => {
      const instrumentsDetail = script.instrumentAry.map((token) => {
        const key = token.instrument_token;

        if (!indexingMap[key]) indexingMap[key] = [];
        indexingMap[key].push([
          rowIndex,
          `${token.original_exchange.toLowerCase()}Detail`,
        ]);

        // debugger;

        return token;
      });

      return { ...script, instrumentsDetail };
    });

    console.log("🚀 ~ useBadlaOrder ~ indexingMap:", indexingMap);
    indexingScriptRef.current = indexingMap;
    setInstrumentData(initialData);
  }, [apiData]);

  // Memo token structure
  const customInstrumentToken = useMemo(() => {
    if (!apiData) return {};

    const obj = {};
    // apiData.forEach((el) => {
    //   obj[el._id] = {
    //     equation: el.equation,
    //     duty: [{ Duty: el?.settingValue?.[0]?.Duty }],
    //     instrument_token: el.instrumentToken.map((y) => `${y}_full`),
    //     settingName: el.settingName,
    //     diffrenceValue: el.diffrenceValue || 0,
    //     reverse: el.reverse,
    //   };
    // });

    return obj;
  }, [apiData]);

  // Socket handler (single update, batched)
  const handleGetInstrument = useCallback((receivedData) => {
    if (!receivedData?.data) return;

    // setInstrumentData((prev) => {
    //   let updated = prev;
    //   let hasChange = false;

    //   receivedData.data.forEach((element) => {
    //     const key = element.instrument_token;
    //     const indexes = indexingScriptRef.current[key];

    //     if (!indexes) return;

    //     indexes.forEach(([parentIndex, childIndex]) => {
    //       const prevParent = updated[parentIndex];
    //       const prevChild = prevParent.instrumentsDetail[childIndex];

    //       // Skip if no change (important for performance)
    //       if (prevChild === element) return;

    //       // clone only when needed
    //       if (!hasChange) {
    //         updated = [...updated];
    //         hasChange = true;
    //       }

    //       const newParent = {
    //         ...prevParent,
    //         instrumentsDetail: [...prevParent.instrumentsDetail],
    //       };

    //       newParent.instrumentsDetail[childIndex] = element;
    //       updated[parentIndex] = newParent;
    //     });
    //   });

    //   return hasChange ? updated : prev;
    // });
  }, []);

  // Socket subscription
  useEffect(() => {
    if (!socket || !Object.keys(customInstrumentToken).length) return;

    socket.connect();

    const tokenString = Object.values(customInstrumentToken)
      .flatMap((e) => e.instrument_token)
      .join(",");

    socket.emit(
      "watch-instruments",
      JSON.stringify({
        roomId: ROOM_ID,
        instrument_token: tokenString,
        marketType: "badla",
        uniqId: UNIQUE_ID,
        equation: customInstrumentToken,
        response_type: "full",
        duty: [],
      }),
    );

    socket.on("instrument-data", handleGetInstrument);

    return () => {
      socket.off("instrument-data", handleGetInstrument);
    };
  }, [socket, customInstrumentToken, handleGetInstrument]);

  return { instrumentData };
};

export default useBadlaOrder;
